const actions = {
    GET_LOCKED_ACTIVATION_REQUEST: 'GET_LOCKED_ACTIVATION_REQUEST',
    GET_LOCKED_ACTIVATION_REQUEST_SUCCESS: 'GET_LOCKED_ACTIVATION_REQUEST_SUCCESS',
    GET_LOCKED_ACTIVATION_REQUEST_FAILED: 'GET_LOCKED_ACTIVATION_REQUEST_FAILED',

    GET_LOCKED_DAILY_PALN_ACTIVATION: 'GET_LOCKED_DAILY_PALN_ACTIVATION',
    GET_LOCKED_DAILY_PALN_ACTIVATION_SUCCESS: 'GET_LOCKED_DAILY_PALN_ACTIVATION_SUCCESS',
    GET_LOCKED_DAILY_PALN_ACTIVATION_FAILED: 'GET_LOCKED_DAILY_PALN_ACTIVATION_FAILED',


    GET_LOCKED_SIM_SWAP_REQUEST: 'GET_LOCKED_SIM_SWAP_REQUEST',
    GET_LOCKED_SIM_SWAP_REQUEST_REQUEST_SUCCESS: 'GET_LOCKED_SIM_SWAP_REQUEST_REQUEST_SUCCESS',
    GET_LOCKED_SIM_SWAP_REQUEST_REQUEST_FAILED: 'GET_LOCKED_SIM_SWAP_REQUEST_REQUEST_FAILED',


    RELESE_ACTIVATION_REQUEST: "RELESE_ACTIVATION_REQUEST",
    RELESE_ACTIVATION_REQUEST_SUCCESSFUL: "RELESE_ACTIVATION_REQUEST_SUCCESSFUL",
    RELESE_ACTIVATION_REQUEST_FAILED: "RELESE_ACTIVATION_REQUEST_FAILED",

    RELESE_DAILY_PLAN_REQUEST: "RELESE_DAILY_PLAN_REQUEST",
    RELESE_DAILY_PLAN_REQUEST_SUCCESSFUL: "RELESE_DAILY_PLAN_REQUEST_SUCCESSFUL",
    RELESE_DAILY_PLAN_REQUEST_FAILED: "RELESE_DAILY_PLAN_REQUEST_FAILED",


    RELESE_SIM_SWAP_REQUEST: "RELESE_SIM_SWAP_REQUEST",
    RELESE_SIM_SWAP_REQUEST_SUCCESSFUL: "RELESE_SIM_SWAP_REQUEST_SUCCESSFUL",
    RELESE_SIM_SWAP_REQUEST_FAILED: "RELESE_SIM_SWAP_REQUEST_FAILED",

    RESET_MESSAGE: "RESET_MESSAGE",

    getLockedActivationRequest: () => ({
        type: actions.GET_LOCKED_ACTIVATION_REQUEST,
    }),
    getLockedActivationRequestSuccess: (lockedActivationResult) => ({
        type: actions.GET_LOCKED_ACTIVATION_REQUEST_SUCCESS,
        lockedActivationResult
    }),
    getLockedActivationRequestFailed: (error) => ({
        type: actions.GET_LOCKED_ACTIVATION_REQUEST_FAILED,
        error
    }),

    getLockedDailyPlanActivation: () => ({
        type: actions.GET_LOCKED_DAILY_PALN_ACTIVATION,
    }),
    getLockedDailyPlanActivationSuccess: (lockedDailyPlanResult) => ({
        type: actions.GET_LOCKED_DAILY_PALN_ACTIVATION_SUCCESS,
        lockedDailyPlanResult
    }),
    getLockedDailyPlanActivationFailed: (error) => ({
        type: actions.GET_LOCKED_DAILY_PALN_ACTIVATION_FAILED,
        error
    }),

    getLockedSIMSwapRequest: () => ({
        type: actions.GET_LOCKED_SIM_SWAP_REQUEST,
    }),
    getLockedSIMSwapRequestSuccess: (lockedSimSwapResult) => ({
        type: actions.GET_LOCKED_SIM_SWAP_REQUEST_REQUEST_SUCCESS,
        lockedSimSwapResult
    }),
    getLockedSIMSwapRequestFailed: (error) => ({
        type: actions.GET_LOCKED_SIM_SWAP_REQUEST_REQUEST_FAILED,
        error
    }),

    releaseActivationRequest: (unLockData) => ({
        type: actions.RELESE_ACTIVATION_REQUEST,
        payload: { unLockData }
    }),
    releaseActivationRequestSuccessful: (message) => ({
        type: actions.RELESE_ACTIVATION_REQUEST_SUCCESSFUL,
        payload: { message }
    }),
    releaseActivationRequestFailed: (error) => ({
        type: actions.RELESE_ACTIVATION_REQUEST_FAILED,
        payload: { error }
    }),

    releaseDailyPlanRequest: (unLockData) => ({
        type: actions.RELESE_DAILY_PLAN_REQUEST,
        payload: { unLockData }
    }),
    releaseDailyPlanRequestSuccessful: (message) => ({
        type: actions.RELESE_DAILY_PLAN_REQUEST_SUCCESSFUL,
        payload: { message }
    }),
    releaseDailyPlanRequestFailed: (error) => ({
        type: actions.RELESE_DAILY_PLAN_REQUEST_FAILED,
        payload: { error }
    }),

    releaseSIMSwapRequest: (unLockData) => ({
        type: actions.RELESE_SIM_SWAP_REQUEST,
        payload: { unLockData }
    }),
    releaseSIMSwapRequestSuccessful: (message) => ({
        type: actions.RELESE_SIM_SWAP_REQUEST_SUCCESSFUL,
        payload: { message }
    }),
    releaseSIMSwapRequestFailed: (error) => ({
        type: actions.RELESE_SIM_SWAP_REQUEST_FAILED,
        payload: { error }
    }),
    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    }),
};
export default actions;
